/* Location Parameters */
export const CHIRP_PRODUCTION_DOMAIN = 'chirp.research.exeter.ac.uk';